const terms_and_conditions = {
  permissionSource: 'api::term-and-condition.term-and-condition',
  creationTitle: 'Create Term And Condition',
  creationEndPoint: '/terms-and-conditions',
  detailTitle: 'Term And Condition: :title',
  detailEndPoint: '/terms-and-conditions/:id?populate=*',
  detail: [
    {
      isLayout: true,
      layoutPattern: '1-1-1',
      children: [
        {
          isLayout: true,
          layoutPattern: '1',
          children: [
            {
              label: 'Code',
              value: 'code',
              tag: 'input',
              type: 'text',
              placeholder: 'Term And Condition Code',
              required: true,
            },
          ],
        },
        {
          isLayout: true,
          layoutPattern: '1',
          children: [
            {
              label: 'Title',
              value: 'title',
              tag: 'input',
              type: 'text',
              placeholder: 'Term And Condition Title',
              required: true,
            },
          ],
        },
        {
          isLayout: true,
          layoutPattern: '1',
          children: [
            {
              label: 'Default',
              value: 'default',
              tag: 'switch',
            },
          ],
        },
      ],
    },
    {
      label: 'Description (Chinese)',
      value: 'description',
      tag: 'richTextarea',
      placeholder: 'Support shortcode: [total], [code] or other customized shortcode',
      popUpText: 'Support shortcode: [total], [code] or other customized shortcode',
      required: true,
    },
    {
      label: 'Description (English)',
      value: 'description_en',
      tag: 'richTextarea',
      placeholder: 'Support shortcode: [total], [code] or other customized shortcode',
      popUpText: 'Support shortcode: [total], [code] or other customized shortcode',
    },
    {
      isLayout: true,
      layoutPattern: '1-1-1',
      children: [
        {
          label: 'Create Date / Time',
          value: 'custom_created_at',
          tag: 'static-text',
        },
        {
          label: 'Update Date / Time',
          value: 'custom_updated_at',
          tag: 'static-text',
        },
      ],
    },
  ],
}
export default terms_and_conditions
